/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_MailInputs */

const da_privacy_data_mail = /** @type {(inputs: Privacy_Data_MailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**E-mail-log:** hvem der har fået en e-mail fra os (modtagerens adresse), hvilken slags e-mail det var, om den blev sendt, og hvornår. Aldrig indholdet eller de links, mailen indeholder.`)
};

/** @type {(inputs: Privacy_Data_MailInputs) => LocalizedString} */
const en_privacy_data_mail = da_privacy_data_mail;

/**

* @param {Privacy_Data_MailInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_data_mail = /** @type {((inputs?: Privacy_Data_MailInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_MailInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_data_mail(inputs)
	return /** @type {LocalizedString} */ ("**E-mail-log:** hvem der har fået en e-mail fra os (modtagerens adresse), hvilken slags e-mail det var, om den blev sendt, og hvornår. Aldrig indholdet eller de links, mailen indeholder.")
});